module.exports = __webpack_public_path__ + "static/media/nre-fd.57e8d759.png";